// Starts a browser download for a URL without opening a new tab.
// Used for presigned S3 URLs from api/cam-mirror/documents/:id/download-url, which the
// backend always signs with `Content-Disposition: attachment` (CamAttachmentsService
// .contentDisposition), so following the link downloads the file and keeps the
// current page. Opening `window.open('', '_blank')` first left an empty about:blank tab.
export function triggerDownload(url: string, fileName?: string): void {
  const link = document.createElement('a');
  link.href = url;
  // Ignored for cross-origin URLs (S3), where the server header decides the name,
  // but useful if the URL is ever same-origin.
  if (fileName) link.download = fileName;
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
